import React, { useState, useEffect } from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { DoctypeModal } from "./DoctypeModal";


import { SearchResultsCarousel } from "./SearchResultsCarousel";
import { SERVER_URL } from "../../constants/constants.js";

import { Mixpanel } from "../../helpers";
import { isTemplateSpan } from "typescript";


function ExpandingTableWithGroups(props) {

  const gridview = require("../../images/gridview.png").default;
  const listview = require("../../images/listview.png").default;

  const { term, data, authentication, org, searchRequest, getDocTypes } = props;
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState([]);
  const [currentJacketPages, setCurrentJacketPages] = useState([]);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [showCarousel, setShowCarousel] = useState(false);
  const [showDoctypeModal, setShowDoctypeModal] = useState(false);
  const [modalX, setModalX] = useState(100);
  const [modalY, setModalY] = useState(100);
  const [modalItem, setModalItem] = useState({});


  const current_token = authentication.jwt;
  const org_id = org?.current_org_id;
  const current_org = org.list?.filter(
    (o) => o.org_id == org_id
  )[0];
  const limit_pipeline = current_org?.limit_pipeline;
  const doc_types = org?.doc_types;

  const user_id = authentication?.user?.user_id;
  const user_org_id = authentication?.user?.org_id;
  const is_admin = authentication?.user?.roles?.includes("ADMIN");

  useEffect(() => {
    getDocTypes(org_id);
  }, [org_id]);

  const toggleCarousel = () => {
    setShowCarousel(!showCarousel);
  };

  const incrementCarousel = (target) => {
    if (currentPageIndex < currentJacketPages?.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
    console.log("incrementing carousel");
  };

  const decrementCarousel = (target) => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
    console.log("decrementing carousel");
  };

  const constructPdfUrl = (item) => {
    return (
      SERVER_URL +
      "/org/" +
      org_id +
      "/dealjacket/" +
      item.deal_jacket_id +
      "/download" +
      "?token=" +
      current_token
    );
  };

  const generateRowHeaders = () => {

    return (
      <>
        <th width="3%" key="doctype"></th>
        <th width="52%" key="file name">file name</th>
        <th width="3%" key="listview"></th>
        <th width="3%" key="gridview"></th>
        <th key="page matches">page matches</th>
        <th key="col4"></th>
        <th key="col5"></th>
      </>
    )
  };

  const handleJacketClick = (rowId) => {
    const currentExpandedRows = expandedRows;
    const isRowCurrentlyExpanded = currentExpandedRows.includes(rowId);

    const newExpandedRows = isRowCurrentlyExpanded
      ? currentExpandedRows.filter((id) => id !== rowId)
      : currentExpandedRows.concat(rowId);

    setExpandedRows(newExpandedRows);
  };

  const handleGroupClick = (groupId) => {
    const currentExpandedGroups = expandedGroups;
    const isGroupCurrentlyExpanded = currentExpandedGroups.includes(groupId);

    const newExpandedGroups = isGroupCurrentlyExpanded
      ? currentExpandedGroups.filter((id) => id !== groupId)
      : currentExpandedGroups.concat(groupId);

    setExpandedGroups(newExpandedGroups);
  };

  const getPageCountWord = (length) => {
    return length === 1 ? "page" : "pages";
  };

  const getGroupCountWord = (length) => {
    return length === 1 ? "group" : "groups";
  };

  const formatMatchText = (text) => {
    var tokenized = text.split(" ");
    var result = tokenized.map((word) => {
      if (word.includes(term.toLowerCase())) {
        var lcTerm = term.toLowerCase();
        if (word === lcTerm) {
          return '<span class="matchTextHighlight">' + word + "</span>";
        } else {
          var termlength = lcTerm.length;
          var startIndex = word.indexOf(lcTerm);
          var endIndex = word.indexOf(lcTerm) + termlength;

          var result =
            word.substring(0, startIndex) +
            '<span class="matchTextHighlight">' +
            lcTerm +
            "</span>" +
            word.substring(endIndex);
          return result;
        }
      } else {
        return word;
      }
    });

    return "..." + result.join(" ") + "...";
  };

  function flattenJacketData(data) {
    var output = [];

    data.groups.forEach(function (group) {
      group.pages.forEach(function (page) {
        var element = {
          deal_jacket_id: Number(data.deal_jacket_id),
          deal_jacket_name: data.deal_jacket_name,
          group_id: Number(group.page_group_id),
          group_name: group.page_group_name,
          page_id: Number(page.page_id),
          page_type_id: Number(page.page_type_id),
          page_type_name: page.page_type_name,
          image_path: SERVER_URL + '/images/' + page.image_path,
        };
        output.push(element);
      });
    });

    return output;
  }


  /**
   * Flatten and Deduplicate
   *
   * Flatten pages, within groups, so we can get an accurate document
   * count, even though docs are duplicated within different groups.
   *
   * @param {array} groups, which contain the pages
   * @return "set": array of unique pages.
   */
  function flattenAndDeDuplicate(groups) {
    let seen = {};
    let set = [];

    groups.forEach(group => {
      group.pages.forEach(page => {
        if (page.page_id in seen) return;
        seen[page.page_id] = 1;
        set.push(page);
      })
    });
    return set;
  }

  const renderItem = (item, index) => {

    var unique_documents = flattenAndDeDuplicate(item.groups);

    const logDownloadClick = (deal_jacket_id) => {
      console.log('logging download click')
      const custom_properties = {
        'tt_user_id': user_id,
        'tt_org_id': org_id,
        'tt_deal_jacket_id': deal_jacket_id
      };
      Mixpanel.track('DownloadPdfFromSearchResults', custom_properties);
    }

    const editDocType = (event, item) => {
      console.log(item);
      console.log(event.pageX + ", " + event.pageY);
      setModalItem(item);
      setModalX(event.pageX);
      setModalY(event.pageY);
      setShowDoctypeModal(true);
    }

    const getCanEditDocType = (item) => {
      if (item.create_user_id === user_id) {
        return true;
      }
      if (is_admin && (user_org_id === 1 || authentication?.user?.adminOrgIds?.includes(org_id))) {
        return true;
      }
      return false;
    }

    const formatDocType = (item) => {
      const doc_type = item.doc_type;
      const can_edit = getCanEditDocType(item);
      var color;
      var code;
      if (doc_types && doc_types.length > 0) {
        //console.log(doc_types);
        const doctypematch = doc_types?.find(doctype => doctype.doc_type === doc_type)
        const colorval = doctypematch?.color;
        code = doctypematch?.labelCode;
        if (colorval) color = "#" + colorval;
      } else {
        color = "#eeeeee";
        code = "DJ";
      }

      return (
        <>
          {
            (can_edit) &&
            <>
              <span className="docTypeLabel" style={{ backgroundColor: color }} data-tip data-for={"docType-" + doc_type} onClick={(e) => editDocType(e, item)}>
                {code}
              </span>
              <ReactTooltip
                id={"docType-" + doc_type}
                place="bottom"
                effect="solid"
                data-type="info"
                delayShow={150}
              >
                Document Type: {doc_type}<br />
                <span style={{ "fontSize": "0.8em" }}>(click to change)</span>

              </ReactTooltip>

            </>
          }
          {!can_edit &&
            <>
              <span className="docTypeLabel" style={{ backgroundColor: color }} data-tip data-for={"docType-" + doc_type}>
                {code}
              </span>
              <ReactTooltip
                id={"docType-" + doc_type}
                place="bottom"
                effect="solid"
                data-type="info"
                delayShow={150}
              >
                Document Type: {doc_type}<br />
              </ReactTooltip>
            </>
          }
        </>
      );


    }

    const itemRows = [
      <tr key={"row-data-" + item.deal_jacket_id}>
        <td className="docTypeLabelCell">
          {formatDocType(item)}
        </td>
        <td className="innerTableContainingCell">
          <table className="innerTable">
            <tbody>
              <tr>
                <td>
                  <div className="downloadLink" data-tip data-for={item.deal_jacket_id}>
                    <span className="truncate" >
                      <a href={constructPdfUrl(item)} onClick={(event) => logDownloadClick(item.deal_jacket_id)}>
                        {item.deal_jacket_name.length > 65
                          ? item.deal_jacket_name.substring(0, 65) + "..."
                          : item.deal_jacket_name}
                      </a>
                    </span>
                    <ReactTooltip
                      id={String(item.deal_jacket_id)}
                      place="bottom"
                      effect="solid"
                      data-type="info"
                      delayShow={500}
                    >
                      {item.deal_jacket_name}
                    </ReactTooltip>
                  </div>
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </td>

        {
          (item.empty) &&
          <>
            <td className="listViewIconCell">&nbsp;</td>
            <td className="gridViewIconCell">&nbsp;</td>
          </>
        }
        {
          !(item.empty) &&
          <>
            <td className="listViewIconCell" data-tip data-for="list view">
              <Link to={{ pathname: "/org/" + org_id + "/dealjacket/" + item.deal_jacket_id + "/list" }}>
                <img width="24px" src={listview} alt="list view" />
              </Link>
              <ReactTooltip
                id="list view"
                place="bottom"
                effect="solid"
                data-type="info"
                delayShow={300}
              >
                view pages in list
              </ReactTooltip>
            </td>

            <td className="gridViewIconCell" data-tip data-for="grid view">
              <Link to={{ pathname: "/org/" + org_id + "/dealjacket/" + item.deal_jacket_id + "/grid" }}>
                <img width="24px" src={gridview} alt="grid view" />
              </Link>
              <ReactTooltip
                id="grid view"
                place="bottom"
                effect="solid"
                data-type="info"
                delayShow={300}
              >
                view pages in grid
              </ReactTooltip>
            </td>

          </>

        }
        {
          (limit_pipeline) &&
          <td className="pagesMatchedCell" colSpan="3">
            <table>
              <tr>
                <td className="matchTextCell">
                  <div
                    className="matchText"
                    dangerouslySetInnerHTML={{
                      __html: formatMatchText(
                        item.groups[0]?.pages[0].match_text
                      ),
                    }}
                  ></div>
                </td>
              </tr>
            </table>
          </td>
        }
        {
          (!limit_pipeline && item.empty) &&
          <td className="pagesMatchedCell" colSpan="3">
            <table className="pageMatchesInnerTable">
              <tbody>
                <tr>
                  <td className="pagesMatchedInfoCell">
                    <div className="viewPageMatches">
                      <a href={constructPdfUrl(item)}>
                        (download only)
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

          </td>
        }
        {
          (!limit_pipeline && !(item.empty)) &&
          <td className="pagesMatchedCell" colSpan="3">
            <table className="pageMatchesInnerTable">
              <tbody>
                <tr>
                  <td colSpan="3" className="pagesMatchedInfoCell">
                    <div
                      className="viewPageMatches"
                      onClick={(e) => handleJacketClick(item.deal_jacket_id, e)}
                    >
                      {unique_documents.length} {getPageCountWord(item.pageCount)} in{" "}
                      {item.groupCount} {getGroupCountWord(item.groupCount)}
                      {expandedRows.includes(item.deal_jacket_id) && (
                        <div className="arrowDown" />
                      )}
                      {!expandedRows.includes(item.deal_jacket_id) && (
                        <div className="arrowRight" />
                      )}
                    </div>
                  </td>
                </tr>
                {expandedRows.includes(item.deal_jacket_id) &&
                  item.groups.map((group, i) => (
                    <tr
                      className="pageGroupNameRow"
                      key={"row-expanded-" + item.deal_jacket_id + "-" + i}
                    >
                      {!expandedGroups.includes(
                        item.deal_jacket_id + "-" + group.page_group_id
                      ) && (
                          <td
                            colSpan="3"
                            className="pageGroupNameCell"
                            onClick={(e) =>
                              handleGroupClick(
                                item.deal_jacket_id + "-" + group.page_group_id,
                                e
                              )
                            }
                          >
                            {group.page_group_name}&nbsp;({group.pages.length})
                          </td>
                        )}
                      {expandedGroups.includes(
                        item.deal_jacket_id + "-" + group.page_group_id
                      ) && (
                          <td colSpan="3">
                            <table className="pageMatchesInnerTable">
                              <tbody>
                                <tr>
                                  <td
                                    colSpan="3"
                                    className="pageGroupNameCell"
                                    onClick={(e) =>
                                      handleGroupClick(
                                        item.deal_jacket_id +
                                        "-" +
                                        group.page_group_id,
                                        e
                                      )
                                    }
                                  >
                                    {group.page_group_name}&nbsp;(
                                    {group.pages.length})
                                  </td>
                                </tr>
                                {group.pages.map((page, i) => (
                                  <tr
                                    className="pageRow"
                                    key={
                                      "row-expanded-" +
                                      item.deal_jacket_id +
                                      "-" +
                                      group.page_group_id +
                                      "-" +
                                      i
                                    }
                                    onClick={() => {
                                      const jacketPages = flattenJacketData(item);
                                      const pageIndex = jacketPages.findIndex(
                                        (p) => p.page_id === page.page_id
                                      );
                                      console.log(jacketPages);
                                      setCurrentJacketPages(jacketPages);
                                      setCurrentPageIndex(pageIndex);
                                      toggleCarousel();
                                    }}
                                  >
                                    <td width="20px">&nbsp;</td>
                                    <td className="pageTypeNameCell">
                                      <span className="reviewLink">
                                        {page.page_type_name}
                                      </span>
                                    </td>
                                    <td className="matchTextCell">
                                      <div
                                        className="matchText"
                                        dangerouslySetInnerHTML={{
                                          __html: formatMatchText(
                                            page.match_text
                                          ),
                                        }}
                                      ></div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </td>
                        )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </td>
        }
      </tr>,
    ];

    return itemRows;
  };

  const generateAllItemRows = () => {
    let allItemRows = [];

    data?.results && data.results.forEach((item, index) => {
      item.org_id = org_id;
      const perItemRows = renderItem(item, index);
      allItemRows = allItemRows.concat(perItemRows);
    });

    return allItemRows;
  };

  const calculateDocTypeModalTop = (modalY) => {
    const windowHeight = window.innerHeight;
    const modalHeight = 140;
    if (modalY + modalHeight > windowHeight) {
      return (windowHeight - modalHeight);
    } else {
      return (modalY - 40);
    }
  };

  return (
    <>
      <div className="docTypeModal" style={{ position: "fixed", top: (calculateDocTypeModalTop(modalY)) + "px", left: (modalX + 24) + "px", visibility: showDoctypeModal ? "visible" : "hidden" }}>
        <DoctypeModal
          org_id={org_id}
          closeModal={() => setShowDoctypeModal(false)}
          item={modalItem}
        />
      </div>
      <table className="searchResults">
        <thead>
          <tr>{generateRowHeaders()}</tr>
        </thead>
        <tbody>{generateAllItemRows()}</tbody>
      </table>
      <div
        className="carouselWrapper"
        style={{ visibility: showCarousel ? "visible" : "hidden" }}
      >
        <div className="closeCarousel" onClick={toggleCarousel}>
          X
        </div>
        <SearchResultsCarousel
          key={currentPageIndex}
          images={currentJacketPages}
          currentImage={currentPageIndex}
          searchRequest={searchRequest}
        />
        <div className="carouselFooter">
          {currentPageIndex === 0 && (
            <div className="carouselBack">
              <span
                className="carouselArrowInactive"
                onClick={decrementCarousel}
              >
                back
              </span>
            </div>
          )}
          {currentPageIndex > 0 && (
            <div className="carouselBack">
              <span className="carouselArrow" onClick={decrementCarousel}>
                back
              </span>
            </div>
          )}
          {currentPageIndex < currentJacketPages.length - 1 && (
            <div className="carouselNext">
              <span className="carouselArrow" onClick={incrementCarousel}>
                next
              </span>
            </div>
          )}
          {currentPageIndex === currentJacketPages.length - 1 && (
            <div className="carouselNext">
              <span
                className="carouselArrowInactive"
                onClick={incrementCarousel}
              >
                next
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org, pagetypes } = state;
  return {
    authentication,
    org,
    pagetypes
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes
};

const connectedExpandingTableWithGroups = connect(mapStateToProps, actionCreators)(ExpandingTableWithGroups);
export { connectedExpandingTableWithGroups as ExpandingTableWithGroups };
